import type { DTOShopPage } from 'src/apis/dto/DTOShopPage';
import type { DTOSubscriptionPageResponse } from 'src/apis/dto/DTOSubscriptionPage';

import type { APIClientType } from '.';

/** 페이지 API */
export interface PageServiceType {
  /**
   * 주어진 페이지 ID의 상점 페이지를 조회한다.
   *
   * @param pageId 조회할 페이지 ID
   * @return 상점 페이지를 나타내는 DTO
   */
  getShopPage: (pageId: string) => Promise<DTOShopPage>;

  /**
   * 통합 구독 페이지를 조회한다.
   *
   * 기본적으로 통합 구독의 구독그룹에 속한 모든 구독상품 페이지를 리스트 형태로 내려준다.
   * 하위 grade 상품 구독자의 경우 업그레이드를 유도하기 위해 상위 grade 상품 페이지를 내려주지만,
   * 상위 grade 상품 구독자의 경우 하위 grade 상품 페이지를 내려주지 않는다.
   */
  getSubscriptionPage: () => Promise<DTOSubscriptionPageResponse>;
}

export class PageService implements PageServiceType {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public getShopPage = async (pageId: string) => {
    return this.client.call<DTOShopPage, void>({
      method: 'GET',
      path: `/api/pages/shop/${pageId}`,
    });
  };

  public getSubscriptionPage = async () => {
    return this.client.call<DTOSubscriptionPageResponse, void>({
      method: 'GET',
      path: '/api/pages/subscriptions',
    });
  };
}
